import React from 'react'

function AdminTasks() {
    return (
        <div>AdminTasks</div>
    )
}

export default AdminTasks